import { faEnvelope } from "@awesome.me/kit-3777c2145e/icons/classic/regular";
import { faPlay, faShield, faBadge } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import type { AbstractStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, List, Stack } from "@shared/ui";
import { NumberFormatter } from "@shared/ui/components/NumberFormatter";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

export type StepFields = {};
interface Props extends AbstractStepProps {
	finalAmount: number;
}
export class Result extends AbstractStep<StepFields, Props> {
	protected renderContent(): ReactNode {
		const { finalAmount } = this.props;

		return (
			<>
				<Card.Header className="bg-transparent text-center">
					<Card.Title as="div" className="display-1 fw-medium text-primary">
						<NumberFormatter.Currency value={Math.floor(finalAmount)} />
					</Card.Title>
					<Card.Title as="div" className="h4">
						Ennyi pénzed lesz mire nyugdíjba mész.
					</Card.Title>
				</Card.Header>
				<Card.Body className="bg-gray py-3" as={Stack} direction="horizontal" gap={3} alignItems="center">
					<div>
						<div className="fa-stack fa-2x">
							<FontAwesomeIcon icon={faBadge} className="fa-stack-2x text-blue" />
							<FontAwesomeIcon icon={faEnvelope} className="fa-stack-1x fa-inverse" size="sm" />
						</div>
					</div>
					<div className="h5 mb-0">
						A részletes eredményedet <strong className="text-nowrap">e-mailben</strong> fogjuk elküldeni
						számodra!
					</div>
				</Card.Body>
				<Card.Body className="py-3">
					<div className="h5 text-center">Szeretnéd megtudni:</div>
					<List itemStyle="tick" variant="blue" size="sm">
						<List.Item>Hogyan lesz ennyi pénzed nyugdíjas éveidre?</List.Item>
						<List.Item>
							Hogy melyik számodra a legmegfelelőbb:
							<br />
							nyugdíjpénztár, nyugdíjbiztosítás vagy NYESZ?
						</List.Item>
						<List.Item>Illetve, hogy mennyi állami támogatást kaphatsz?</List.Item>
					</List>
				</Card.Body>
				<Card.Footer className="text-center">
					<div className="text-blue text-center fw-medium mb-3">
						<FontAwesomeIcon icon={faShield} className="mr-1" fixedWidth size="lg" />
						Bízd magad független szakértőinkre!
					</div>
					<Button type="submit" icon={<FontAwesomeIcon icon={faPlay} />}>
						Kérem a részletes eredményem!
					</Button>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "Result";
	}
}
